import { Inject, inject, Injectable } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot, Routes } from "@angular/router";
import { OktaAuthService } from "../service/okta-auth.service";
import { UserLoginService } from "../../common/service/user-login.service";
import { environment } from '../../../environments/environment';
import { MessageServiceService } from "../../feature/pilms/service/message-service.service";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";


@Injectable({
    providedIn: 'root'
})
class RoleGuardSevice {

    constructor(
        @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,

        private oktaAuthService: OktaAuthService,
        private userLoginService: UserLoginService,
        private messageServiceService: MessageServiceService,
        private router: Router,


    ) { }

    async isUserValid(route: ActivatedRouteSnapshot): Promise<boolean> {
        try {

            let roles: any[] = JSON.parse(sessionStorage.getItem('userRoles') ?? '[]');
            let reportRoles: any[] = JSON.parse(sessionStorage.getItem('reportRoles') ?? '[]');
            let userDetails = JSON.parse(sessionStorage.getItem('userDetails') ?? '{}');

            if (roles.length == 0 || !userDetails?.name) {
                const user = await this.oktaAuthService.getUser();
                if (!user)
                    return false;

                if (!this.userLoginService.isUserExists) {
                    let rest = await this.userLoginService.userExistsCheck(user.preferred_username || user.email);
                    userDetails = rest;

                    this.userLoginService.isUserExists = true;

                    reportRoles = rest.reportRoles || [];
                    roles = rest.roles;
                } else {

                    let rest = await this.userLoginService.fetchUserDetails(user.email);
                    userDetails = rest;

                    reportRoles = rest.reportRoles || [];
                    roles = rest.roles;
                }
            } else {
                this.userLoginService.userName$.next(userDetails?.name ?? '');
                this.userLoginService.userPermission$.next(userDetails.roles);
                this.messageServiceService.setuserIdMessage({ userId: userDetails.id ?? 0 });
            }

            let mergePermission: any = [...roles, ...reportRoles];

            let allReportRole = ['pv w/ characteristics', 'pv w/ raw materials', 'cofa europe report', 'rm w/ characteristics'];
            if (reportRoles.includes('All')) {
                mergePermission = [...mergePermission, ...allReportRole];
            }
            let isUserValid = mergePermission.some((role: string) => route.data['roles'].includes(role));

            if (!isUserValid) {
                let isPILMSAccessOnly = !mergePermission?.includes('GeneralUser') && !mergePermission?.includes('CSMBackoffice')
                    && (mergePermission?.includes('PILAdmin') || mergePermission?.includes('PILMarketing'));

                if (isPILMSAccessOnly) {
                    this.router.navigate(['/PILMS']);
                    return false;
                }

            }

            if (!isUserValid && route.data['redirectURL'] != "") {
                localStorage.clear();
                sessionStorage.clear();
                //  this.oktaAuth.tokenManager.removeRefreshToken();
                // this.oktaAuth.tokenManager.clearPendingRemoveTokens();

                this.oktaAuth.signOut().then(() => {
                    window.location.href = route.data['redirectURL'];
                });
                return false;
            }
            if (route.data['cPage'] !== "MaterialDetails") {

                this.userLoginService.setUserLoggedIn(true);
            }
            return isUserValid;
        } catch (error) {
            console.error('Error in isUserValid:', error);
            this.router.navigate(['/login']);
            return false;
        }
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // sessionStorage.setItem('originalUrl', state.url);
        return this.isUserValid(route);
    }
}

export const RoleAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(RoleGuardSevice).canActivate(route, state);
};